module.exports = __webpack_public_path__ + "img/Kovacs_Szecsi_Henrieta_2026.1b661628.jpg";